import { CopyWorkspace } from './copyWorkspace'
import { TestLinkage } from './testLinkage'
import { useDevToolsEnabled } from './useDevToolsEnabled'

export const DevTools = () => {
  const devToolsEnabled = useDevToolsEnabled()

  if (!devToolsEnabled) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: 9999,
        padding: '1rem',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '1rem',
      }}
    >
      <div style={{ fontWeight: 'bold' }}>DevTools</div>
      <CopyWorkspace />
      <TestLinkage />
    </div>
  )
}
